export const BRAND_LADDER_MODEL = "brand_ladder_model"
export const BRAND_LADDER_LOCAL_FILTER = "brand_ladder_local_filter"